export { default } from './SectionChart';